"use strict";
/*
 * @Author: lihaitao
 * @Date: 2020-05-28 14:23:50
 * @Last Modified by: lihaitao
 * @Last Modified time: 2020-06-01 19:23:33
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 数据处理扩展参数
 */
// interface ExtendConfig {
//   oss?: string
//   cos?: string
// }
class ProcessBase {
    constructor(config) {
        this.config = config || {
            type: 'oss'
        };
    }
    /**
     * 通过参数配置获取图片链接
     * @param config 图片处理配置
     */
    processImage(url, config) {
        let typeMap = {
            oss: this.processToOSSImage,
            cos: this.processToCOSImage
        };
        const { type } = this.config;
        return typeMap[type](url, config);
    }
    /**
     * 腾讯云图片处理
     * @param type 平台类型
     * @param config 配置参数
     * @returns 返回图片处理 url 拼接字符串
     */
    processToCOSImage(url, config) {
        const processURL = `${url}?imageView2/1/w/${config.resize.w}/h/${config.resize.h}`;
        return processURL;
    }
    /**
     * 阿里云图片处理
     * @param type 平台类型
     * @param config 配置参数
     * @returns 返回图片处理 url 拼接字符串
     */
    processToOSSImage(url, config) {
        const processURL = `${url}?x-oss-process=image/resize,w_${config.resize.w},h_${config.resize.h}`;
        return processURL;
    }
}
exports.default = ProcessBase;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvY2Vzc0Jhc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL1Byb2Nlc3NCYXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7R0FLRzs7QUFtQ0g7O0dBRUc7QUFDSCwyQkFBMkI7QUFDM0IsaUJBQWlCO0FBQ2pCLGlCQUFpQjtBQUNqQixJQUFJO0FBRUosTUFBTSxXQUFXO0lBQ2YsWUFBYSxNQUFjO1FBQ3pCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxJQUFJO1lBQ3RCLElBQUksRUFBRSxLQUFLO1NBQ1osQ0FBQTtJQUNILENBQUM7SUFJRDs7O09BR0c7SUFDSCxZQUFZLENBQUUsR0FBVyxFQUFFLE1BQXFCO1FBQzlDLElBQUksT0FBTyxHQUFRO1lBQ2pCLEdBQUcsRUFBRSxJQUFJLENBQUMsaUJBQWlCO1lBQzNCLEdBQUcsRUFBRSxJQUFJLENBQUMsaUJBQWlCO1NBQzVCLENBQUE7UUFDRCxNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQTtRQUM1QixPQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDbkMsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0gsaUJBQWlCLENBQUUsR0FBVyxFQUFFLE1BQXFCO1FBQ25ELE1BQU0sVUFBVSxHQUFHLEdBQUcsR0FBRyxtQkFBbUIsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLE1BQU0sTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsQ0FBQTtRQUNsRixPQUFPLFVBQVUsQ0FBQTtJQUNuQixDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSCxpQkFBaUIsQ0FBRSxHQUFXLEVBQUUsTUFBcUI7UUFDbkQsTUFBTSxVQUFVLEdBQUcsR0FBRyxHQUFHLGlDQUFpQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsTUFBTSxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxDQUFBO1FBQ2hHLE9BQU8sVUFBVSxDQUFBO0lBQ25CLENBQUM7Q0FDRjtBQUVELGtCQUFlLFdBQVcsQ0FBQSJ9